import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Global error handler for extension-related errors
window.addEventListener("error", (event) => {
  // Check if error is from browser extension content scripts
  if (
    event.message &&
    (event.message.includes("contentScript") ||
      event.message.includes("Extension") ||
      event.message.includes("chrome-extension://") ||
      event.message.includes("Request timeout for"))
  ) {
    console.warn("Browser extension error suppressed:", event.message);
    event.preventDefault();
    return true; // Prevents the error from propagating
  }
});

// Handle unhandled promise rejections from extensions
window.addEventListener("unhandledrejection", (event) => {
  if (
    event.reason &&
    typeof event.reason === "string" &&
    (event.reason.includes("contentScript") ||
      event.reason.includes("Extension") ||
      event.reason.includes("chrome-extension://"))
  ) {
    console.warn(
      "Browser extension promise rejection suppressed:",
      event.reason
    );
    event.preventDefault();
  }
});

// Scrollbar visibility logic
let scrollTimer = null;

const handleScroll = () => {
  // Show scrollbar when scrolling
  document.body.classList.add("scrolling");

  // Clear existing timer
  if (scrollTimer) {
    clearTimeout(scrollTimer);
  }

  // Hide scrollbar after scrolling stops (1.5 seconds)
  scrollTimer = setTimeout(() => {
    document.body.classList.remove("scrolling");
  }, 1500);
};

// Check if content is scrollable on load and resize
const checkScrollable = () => {
  const isScrollable = document.body.scrollHeight > window.innerHeight;
  if (!isScrollable) {
    document.body.classList.remove("scrolling");
  }
};

// Add event listeners when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  window.addEventListener("scroll", handleScroll);
  window.addEventListener("resize", checkScrollable);
  checkScrollable(); // Initial check
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
